import { useEffect } from "react";
const useStopPropagation = (ref, events) => {
  const handleEvent = (e) => e.stopPropagation();
  useEffect(() => {
    events.forEach((name) => {
      var _a;
      return (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.addEventListener(name, handleEvent);
    });
    return () => events.forEach((name) => {
      var _a;
      return (_a = ref.current) == null ? void 0 : _a.removeEventListener(name, handleEvent);
    });
  }, [ref]);
};
export {
  useStopPropagation
};
//# sourceMappingURL=usestopPropagation.js.map
